export const SUCCESS_GET_USERS = 'SUCCESS_GET_USERS';
export const FAILED_GET_USERS = 'FAILED_GET_USERS';
export const SUCCESS_GET_USER = 'SUCCESS_GET_USER';
export const FAILED_GET_USER = 'FAILED_GET_USER';
export const SUCCESS_CREATE_USER = 'SUCCESS_CREATE_USER';
export const FAILED_CREATE_USER = 'FAILED_CREATE_USER';
export const SUCCESS_UPDATE_USER = 'SUCCESS_UPDATE_USER';
export const FAILED_UPDATE_USER = 'FAILED_UPDATE_USER';
export const SUCCESS_DELETE_USER = 'SUCCESS_DELETE_USER';
export const FAILED_DELETE_USER = 'FAILED_DELETE_USER';
export const SET_LOCAL_FILTER_CLIENTPK = 'SET_LOCAL_FILTER_CLIENTPK';
export const SET_FETCH_USERS_FLAG = 'SET_FETCH_USERS_FLAG';
export const SUCCESS_GET_CREATED_FOR_INFOS = 'SUCCESS_GET_CREATED_FOR_INFOS';
export const FAILED_GET_CREATED_FOR_INFOS = 'FAILED_GET_CREATED_FOR_INFOS';



// WEBPACK FOOTER //
// ./src/state/constants/userConstants.js